/* HaGroupViewRenderer.js */

"use strict";
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;

class HaGroupViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("ha-pair-device-view-gl");
        this._rootElem.component = this._model;
        this._availGridContainer = document.createElement("avail-grid-container");
        this._availFilterComponent = document.createElement("game-editor-header-gl");
        this._availFilterComponent.classList.add("ge-header");
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    /**
     * Generate
     */
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));

        if (this._model._haPairFeed) {
            this._model._haPairFeed.on("EntityAdded", (this._addPairedDevice = this._addPairedDevice.bind(this)));
            this._model._haPairFeed.on("EntityRemoved", (this._removePairedDevice = this._removePairedDevice.bind(this)));
        }
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        //this._model.removeListener("PagingFeedChange", this._onPagingFeedChange);
        if (this._model._haPairFeed) {
            this._model._haPairFeed.removeListener("EntityAdded", this._addPairedDevice);
            this._model._haPairFeed.removeListener("EntityRemoved", this._removePairedDevice);
        }
    }

    _registerAvailGridListeners() {
        this._availableTargetsGrid.on("UserSelectedRows", (this._onAvailGridUserSelectedRows = this._onAvailGridUserSelectedRows.bind(this)));
        this._availableTargetsGrid.on("BasicSearchFilterChangeData", (this._onUserSelectFilter = this._onUserSelectFilter.bind(this)));
    }

    _unregisterAvailGridListeners() {
        this._availableTargetsGrid.removeListener("UserSelectedRows", this._onAvailGridUserSelectedRows);
        this._availableTargetsGrid.removeListener("BasicSearchFilterChangeData", this._onUserSelectFilter);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._availGridContainer);
        }
        return Promise.resolve()
            .then(() => {
                return this._model.whenFeedReady();
            })
            .then(() => {
                this._renderAvailGrid();
                this._registerListeners();
            })
            .then(() => {
                this._selectPairedDevice();
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    get selectedRows() {
        return this._availableTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderAvailGrid() {
        this._availGridContainer.innerHTML = "";
        this._availableTargetsGrid = new EntityGrid({
            singleSelect: true,
            columns: this._model.availColumnConfig,
            pagingFeed: this._model.availableTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}`,
            showLinesNumber: true,
            useUserDataStorage: false,
            filterComponent: this._availFilterComponent
        });
        this._availGridContainer.appendChild(this._availFilterComponent);
        this._availGridContainer.appendChild(this._availableTargetsGrid.renderer.rootElement);
        this._availableTargetsGrid.renderer._emptyMessage.innerHTML = "No devices available"; //22870 - Change msg
        this._registerAvailGridListeners();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onAvailGridUserSelectedRows(e) {
        this._model._addRemoveHaPair(e.selectedRows);

        if (!_.isEmpty(e.selectedRows[0])) {
            this._model._getDeviceNameById(e.selectedRows[0]).then((deviceName) => {
                this._model._device.setProperty("haPairName", deviceName.getName());
                if (deviceName.getName() !== _.get(this._model._device, "pristineProperties.haPairName")) {
                    this._model._deviceDetails._renderer._hideViewActions();
                } else {
                    this._model._gameEditor.clearPendingRelationshipsFor("haPair", this._model._device);

                    if (!this._model._device.isDirty()) {
                        this._model._deviceDetails._renderer._isDirty = false;
                        this._model._deviceDetails._gameEditor.getTabCmpnt().setDirty(false);
                    }
                }
            });
        } else if (
            _.isEmpty(e.selectedRows[0]) &&
            !_.isEmpty(this._model._device.getPendingRelationships().filter((item) => item.action === "clear" && item.relName === "haPair"))
        ) {
            this._model._deviceDetails._renderer._hideViewActions();
        }
    }
    _onUserSelectFilter() {
        if (this._availableTargetsGrid) {
            let oldQuery = _.get(this._model._userGridData.getBasicSearchData(), "filterQuery", {});
            let filterQuery = this._model._filterQuery(oldQuery);
            return this._model._availableDevicesPagingFeed._deviceAvilaFeedReestablish(filterQuery);
        }
    }
    _addPairedDevice(addedDevcie) {
        this._onUserSelectFilter().then(() => {
            let ids = [addedDevcie.id];
            this.model._pairedDevice = [addedDevcie.id];
            this.model.resetSelection(ids);
        });
    }
    _removePairedDevice() {
        if (this._model) {
            this._model._pairedDevice = [];
            this._model.resetSelection();
        }
    }
    _selectPairedDevice() {
        if (!_.isEmpty(this._model._haPairFeed.cache)) {
            let ids = Object.keys(this._model._haPairFeed.cache);
            this._model.resetSelection(ids);
            this._model.loadAndScrollTo(ids[0]);
        }
    }
    _onShutdown() {
        let shutdowns = [this._availableTargetsGrid.shutdown()];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                this._unregisterAvailGridListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._availGridContainer.remove();
                this._availGridContainer = undefined;
                this._availableTargetsGrid = undefined;
                this._availFilterComponent = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = HaGroupViewRenderer;
